import { c as _c } from "react/compiler-runtime";
import { gql, useQuery } from '@material-bank/graphql-client';
export type BrandConfigQueryData = {
  brandConfig: {
    contactRecipients: {
      mode: 'DEFAULT' | 'GENERAL_CONTACT';
      email: string | null;
      phoneNumber: string | null;
    };
    contactOptions: {
      leadTime: boolean;
      pricing: boolean;
      other: boolean;
      text: boolean;
      call: boolean;
    };
  };
};
export type BrandConfigQueryVars = {
  brandRef: string;
};
const brandConfigQuery = gql`
  query BrandConfig($brandRef: String!) {
    brandConfig(brandRef: $brandRef) {
      contactRecipients {
        mode
        email
        phoneNumber
      }
      contactOptions {
        leadTime
        pricing
        other
        text
        call
      }
    }
  }
`;
export function useBrandConfigQuery(options) {
  const $ = _c(6);
  let t0;
  if ($[0] !== options) {
    t0 = {
      ...options,
      errorPolicy: "all"
    };
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data,
    error,
    loading
  } = useQuery(brandConfigQuery, t0);
  const t1 = data?.brandConfig;
  let t2;
  if ($[2] !== error || $[3] !== loading || $[4] !== t1) {
    t2 = {
      data: t1,
      error,
      loading
    };
    $[2] = error;
    $[3] = loading;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}